import { useAccount } from '~publish/contexts/AccountContext'

export const useTimeFormatPreference = (): '12' | '24' => {
  const account = useAccount()
  return account?.account?.preferences?.timeFormat === '12' ? '12' : '24'
}
